import ActiveRecord from './active_record/base'

class Environment extends ActiveRecord {
	static tableName = 'environments'
	static sort = 'naam'
}

export default Environment
